

let pad = (v) => {
    return v < 10 ? '0'+v : v
}

const getDateTimeUserFormatted = (dateStr, opts) => {
    let intlOpts = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }
    if (opts.showSeconds) {
        intlOpts.second = '2-digit'
    }
    if (opts.showMs) {
        intlOpts.fractionalSecondDigits = 3
    }
    return new Intl.DateTimeFormat(navigator.language,intlOpts ).format(new Date(dateStr))
};

const getTimeUserFormatted = (dateStr, opts) => {
    let intlOpts = {
        hour: '2-digit',
        minute: '2-digit',
    }
    if (opts.showSeconds) {
        intlOpts.second = '2-digit'
    }
    if (opts.showMs) {
        intlOpts.fractionalSecondDigits = 3
    }
    return new Intl.DateTimeFormat(navigator.language,intlOpts ).format(new Date(dateStr))
}


export {
    getTimeUserFormatted,
    getDateTimeUserFormatted
}